import { ToastStack } from '@odo/shared-ui/components/ToastStack';
import { useToast } from '../providers/ToastProvider';

export function ToastContainer() {
    const { toasts, removeToast } = useToast();
    return <ToastStack toasts={toasts} onDismiss={removeToast} />;
}
